import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { UI } from '../theme';

// Lightweight in-app toast. Pub/sub via a window CustomEvent so any module
// can fire `toast('message')` without importing the host component.
// (Avoids pulling in the sonner dep just for a few "เร็วๆ นี้" alerts.)

const EVT = 'tl-toast';

export function toast(message, opts = {}) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(EVT, {
    detail: { id: Date.now() + Math.random(), message, tone: opts.tone || 'default', duration: opts.duration ?? 2800 },
  }));
}

export default function ToastHost({ theme }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const handle = (e) => {
      const t = e.detail;
      if (!t || !t.message) return;
      setItems(prev => [...prev, t]);
      setTimeout(() => setItems(prev => prev.filter(x => x.id !== t.id)), t.duration);
    };
    window.addEventListener(EVT, handle);
    return () => window.removeEventListener(EVT, handle);
  }, []);

  if (typeof document === 'undefined') return null;

  return createPortal(
    <div
      data-testid="tl-toast-host"
      style={{
        position: 'fixed',
        left: '50%', transform: 'translateX(-50%)',
        bottom: 'calc(112px + env(safe-area-inset-bottom))',
        zIndex: 9999,
        display: 'flex', flexDirection: 'column', gap: 8,
        pointerEvents: 'none', maxWidth: 'min(420px, 92vw)',
      }}
    >
      {items.map(t => (
        <div
          key={t.id}
          data-testid="tl-toast-item"
          className="tl-v2-slide-up"
          style={{
            background: t.tone === 'error' ? '#FECACA' : (theme?.text || '#2D1B4E'),
            color: t.tone === 'error' ? '#7F1D1D' : '#fff',
            padding: '12px 18px', borderRadius: 999,
            fontFamily: UI, fontSize: 13, fontWeight: 600,
            boxShadow: '0 6px 20px rgba(0,0,0,0.25)',
            pointerEvents: 'auto',
            textAlign: 'center',
          }}
        >{t.message}</div>
      ))}
    </div>,
    document.body
  );
}
